import { render, staticRenderFns } from "./globalUploader.vue?vue&type=template&id=3125d8d1&scoped=true"
import script from "./globalUploader.vue?vue&type=script&lang=js"
export * from "./globalUploader.vue?vue&type=script&lang=js"
import style0 from "./globalUploader.vue?vue&type=style&index=0&id=3125d8d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3125d8d1",
  null
  
)

export default component.exports